/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createServicesSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: 'calc(100% * (127 / 1440)) calc(100% * (190 / 1440)) calc(100% * (140 / 1440))',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    plxServicesBlock: {
      width: '100%',
    },
    title: {
      width: '100%',
      textAlign: 'center',
      marginBottom: '100px',
    },
    plxServicesCard: {
      height: '100%',
    },
    card: {
      borderRadius: '8px',
      border: '1px solid #EEEEEE',
      padding: '30px 32px 40px',
      display: 'inline-flex',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      textDecoration: 'none',
    },
    cardLink: {
      transition: 'box-shadow 0.2s linear',
      '&:hover': {
        cursor: 'pointer',
        boxShadow: '0px 0px 0px 1px #EEEEEE inset',
      },
    },
    cardNoLink: {
      backgroundColor: '#F6F7F8',
      borderColor: '#F6F7F8',
    },
    cardTitle: {
      textAlign: 'center',
      fontSize: '24px',
      lineHeight: '40px',
      marginBottom: '20px',
    },
    cardText: {
      textAlign: 'center',
      letterSpacing: 'normal',
      '& > i': {
        textDecoration: 'underline',
        fontStyle: 'none',
        color: theme.palette.secondary.main,
      },
    },
  }),
);

export { createServicesSectionStyles };
